<template>
  <section class="content checkout-content wp_AllPageMarginTop wp_MarginBottomAllPage">
    <div
      class="col-12 col-md-8 px-4 mx-auto mt-5 mt-md-0 pt-3"
      style="background-color: white;"
    >
      <div class="row pr-0 mr-0">
        <div class="col-12 pr-0 mr-0">
          <h3 id="rate-product-head"
														data-test="orderReturnHeading">
            <b id="rate-product-head1"
															data-test="orderReturnHeadingBold">
              Product Return
            </b>
          </h3>
        </div>
        <div class="col-4 col-md-3 col-lg-2 ">
          <div class="tracker-left-img">
            <img
              v-if="orders.product_image"
              :src="orders.product_image"
              :alt="orders.product_name"
              :id="'rate-pdt-img-'+orders.product_name"
              style="width: 6em; height: 6em;object-fit: contain;"
														data-test="orderReturnPdtImg"
            >
            <img
              v-else
              src="/img/icons/noImage.jpg"
              :alt="orders.product_name"
              :id="'rate-pdt-img-'+orders.product_name"
														data-test="orderReturnNoPdtImg"
            >
          </div>
        </div>
        <div class="col-8 col-md-5 col-lg-6   tracker-prdct-name">
          <h5 :id="orders.product_name"
														data-test="orderReturnPdtName">
            {{orders.product_name}}
          </h5>
          <p :id="'rate-pdt-price-'+orders.product_name"
													data-test="orderReturnPdtPrice">
            Price: Rs. {{orders.price | currencyConversion}}
          </p>
        </div>
        <div
          class="col-12 col-md-3 col-lg-4 offset-7
                      offset-md-0 pr-0 prdt-rating-stars pr-0"
          :id="'rate-pdt-rate-'+orders.product_name"
        >
          <!--<star-rating v-model="returnProduct.rating"-->
          <!--:show-rating="false"-->
          <!--&gt;-->
          <!--</star-rating>-->
          <!--<span style="color: rgb(255,0,0);"-->
          <!--v-if="returnError"-->
          <!--&gt;-->
          <!--{{ returnErrorMessage }}-->
          <!--</span>-->
        </div>
        <div class="col-12 pr-0 mr-0">
          <div class="form-group mt-3">
            <!--<input type="text" class="form-control"-->
            <!--aria-describedby="helpId"-->
            <!--placeholder="Title"-->
            <!--v-model="returnProduct.returnProduct_title"-->
            <!--name="returnProductTitle"-->
            <!--v-validate="'required'"-->
            <!--:class="{ 'is-invalid': errors.has('returnProductTitle')}"-->
            <!--id="returnProduct-title"-->
            <!--&gt;-->
            <!--<span class="invalid-feedback">-->
            <!--{{ errors.first('returnProductTitle') }}-->
            <!--</span>-->
            <textarea
              class="form-control mt-2"
              rows="5"
              id="comment"
              v-model="returnProduct.returnProduct_text"
              name="returnProduct"
              v-validate="'required'"
              placeholder="returnProduct"
              :class="{ 'is-invalid': errors.has('returnProduct')}"
														data-test="orderReturnComment"
            >
            Reason for returnProduct
          </textarea>
            <span class="invalid-feedback"
																		data-test="orderReturnCommentError"
																		id="orderReturnCommentError">
              {{ errors.first('returnProduct') }}
            </span>
            <!--<label for="file-upload" class="col-12 pt-4 returnProduct-label">-->
            <!--Tap to upload Images (you can upload maximum 5 images)-->
            <!--<input type="file"-->
            <!--multiple-->
            <!--accept="image/*"-->
            <!--@change="uploadImages"-->
            <!--id="file-upload"-->
            <!--style="display: none"-->
            <!--/>-->
            <!--</label>-->
            <!--<div v-if="returnProduct.image_urls" class="row">-->
            <!--<div class="pr-0 mr-0" v-for="images in returnProduct.image_urls"-->
            <!--style="border-radius:2px;position: relative;width: 100px;height: 100px">-->
            <!--<span style="position: absolute;top: 0; right: 0">x</span>-->
            <!--<img class="col-3 pr-1 mr-1 mb-4" :src=images style="width: 100%; height: 100%">-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="returnProduct-images-wrapper">-->
            <!--<div class="wp_userreturnProductImage"-->
            <!--v-for="(images,index) in returnProduct.image_urls"-->
            <!--:key="index"-->
            <!--&gt;-->
            <!--<img :src=images alt="User returnProduct Image">-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="col-12 pr-0 mr-0">-->
            <!--<img  class="col-3 pr-1 mr-1 mb-4"
            v-for="images in imageUrls"
            :src=images
            style="width: 75px; height: 100px">-->
            <!--</div>-->
            <!--<button class="btn btn-primary btn-type-primary mt-2" @click.prevent="upload">-->
            <!--upload-->
            <!--</button>-->
            <button
              class="btn btn-primary btn-type-primary mt-2"
              role="button"
              @click.prevent="returnProductData()"
              :disabled="(returnProduct.returnProduct_text === '')"
              id="rate-returnProduct-btn"
														data-test="orderReturnSubmitBtn"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { productApi } from '../../../../../../services/ApiServices/productApi'
import { orderApi } from '../../../../../../services/ApiServices/orderApi'

export default {
	name: 'order-return',
	data () {
		return {
			returnProduct: {
				returnProduct_text: ''
			},
			orders: Object,
			productId: '',
			returnError: false,
			// returnErrorMessage: 'Rating is required.',
			images: [],
			selectedImages: [],
			imageUrls: []
		}
	},
	mounted () {
		if (this.$route.query.orderProductId) {
			this.productId = this.$route.query.orderProductId
			productApi.getProductsByIds([this.productId]).then((res) => {
				if (res.data && res.data[0]) {
					this.orders = res.data[0]
					if (this.orders.product_details && this.orders.product_details.image_URL_1) {
						this.orders.product_image = this.orders.product_details.image_URL_1
					}
					if (this.orders.vendor_product_inventories &&
            this.orders.vendor_product_inventories[0] &&
            this.orders.vendor_product_inventories[0].price) {
						this.orders.price = this.orders.vendor_product_inventories[0].price
					}
				}
			})
		}
	},
	methods: {
		returnProductData () {
			if (this.returnProduct.returnProduct_text === '') {
				this.returnError = true
				this.$toasted.show(' You should provide proper reason to return',
					{ icon: 'exclamation-circle' }
				)
			} else {
				this.returnProduct.product_id = this.productId

				orderApi.orderReturn(this.$route.query.orderNumber, this.productId, this.$route.query.orderVendorId, this.returnProduct.returnProduct_text)
					.then((res) => {
						this.$toasted.show(res.body.message,
							{ icon: 'exclamation-circle' }
						)
						this.returnProduct.returnProduct_text = ''
						this.$router.push({
							path: '/user/orders' })
					})
					.catch((e) => {
					})
			}
		}
	}
}
</script>

<style scoped>
</style>
